// extracted by mini-css-extract-plugin
export var attachment = "caseStudy-module--attachment--1dd84";
export var copyContainer = "caseStudy-module--copy-container--a6c99";
export var cta = "caseStudy-module--cta--6a2c3";
export var ctaLink = "caseStudy-module--cta-link--b23eb";
export var heading = "caseStudy-module--heading--379da";
export var label = "caseStudy-module--label--65bda";
export var labelGroup = "caseStudy-module--label-group--25abf";
export var logo = "caseStudy-module--logo--776b6";
export var mainCopy = "caseStudy-module--main-copy--8b877";
export var partnerLogos = "caseStudy-module--partner-logos--2caa6";
export var percent = "caseStudy-module--percent--95483";
export var relatedCaseStudies = "caseStudy-module--related-case-studies--c1284";
export var sidebar = "caseStudy-module--sidebar--40f7a";
export var sidebarWrapper = "caseStudy-module--sidebar-wrapper--cc123";
export var stat = "caseStudy-module--stat--036fa";